import { Action } from 'redux-actions';

import { SET_SELECTED_FARE_GROUP } from './actions';

const defaultState = 'Standard';

export const selectedFareGroupReducer = (state: string = defaultState, action: Action<string>) => {
	if (action.type === SET_SELECTED_FARE_GROUP) {
		return action.payload;
	}

	return state;
};
